$('.livingelixir').click(function(){
       if(!$(this).hasClass("activebutton")){
      $(".activebutton").removeClass("activebutton");
      $(this).addClass("activebutton");
      $("#logo-image-svg").html($(this).html());
      var pickname = $(this).data("icon");
      $('.option_icon').text(pickname);
      $('.chooseiconpick').val(pickname);
       }else{
            return false;//this prevents flicker
       }
    });

var accItem = document.getElementsByClassName('accordionItem');
var accHD = document.getElementsByClassName('accordionItemHeading');
for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
}
function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
        this.parentNode.className = 'accordionItem open';
    }
}

$(document).ready(function() {
    $('.faq_group .accordionWrapper').each(function () {
      if (!$(this).children('.accordionItem').length) {
        $(this).parent().hide();
      }
    });
  
    $('.onetime').click(function(e) {  
      $(".livingelixirfrequencynumber").val("");
      $(".livingelixirintervalsunittype").val("");
      $("#Quantity-ss-product-template").val("1");
      $("#Quantity-ss-product-template").prop("readonly", false);
      $(".livingelixirfrequencynumber").attr('name', '');
      $(".livingelixirintervalsunittype").attr('name', '');
      $(".livingelixiradditional").attr('name', 'properties[additional_details]');
      $(".livingelixiradditional").val("A one-time purchase of the Saint Supply Living Elixir includes a 250 ml/ 8.5 fl.oz bottle of Organic Extra Virgin Olive Oil and one 40ml drinking glass to begin your ritual of resilience.");
      $(".addtocartmain").show();
      $(".onebottle, .twobottles, .threebottles, .fourbottles").hide();
      $("#product_form_5687288791208 .price-item.price-item--regular").text("$68.00");
       $(".shopify-payment-button__more-options").show();  
       $(".paynow-wrapper").hide();
    });
});
$(document).ready(function() {
    $('.subscribe').click(function(e) {  
        $(".livingelixirfrequencynumber").val("1");
        $(".livingelixirintervalsunittype").val("Months");
      $("#Quantity-ss-product-template").val("1");
      $("#Quantity-ss-product-template").prop("readonly", true);
      $(".livingelixirfrequencynumber").attr('name', 'properties[shipping_interval_frequency]');
      $(".livingelixirintervalsunittype").attr('name', 'properties[shipping_interval_unit_type]');
      $(".randomproductid").attr('name', 'properties[Cart Item ID]');
      $(".livingelixiradditional").attr('name', 'properties[additional_details]');
      $(".livingelixiradditional").val("Includes: <b>1x=</b> introductory Living Elixir box (250 ml/8.5 fl. oz Organic Extra Virgin Olive Oil with a complimentary 40 ml drinking glass). \n 3x additional bottles (250 ml/8.5 fl. oz) for a full month's supply of a daily intake of Saint Supply Living Elixir.");
//       $(".addtocartmain").hide();
      $(".subscriptionbutton").show();
      $("#product_form_5687288791208 .price-item.price-item--regular").text("$272.00");
//       $(".shopify-payment-button__more-options").hide();  
//       $(".paynow-wrapper").show();
    });
});

$(document).ready(function() {
	var pathname = window.location.pathname;
  	if(pathname.indexOf("/cart")>-1){
      var intval = setInterval(function(){  
        if( $("#ms__toggle-box").length>0 ){
          $("#ms__toggle-shipping").attr("disabled",false);
          $("#ms__toggle-box").attr("title","");
          jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items;
            for(var i=0; i < items.length; i++){
              if('36907848564904' == items[i].id){
                $("#ms__toggle-shipping").attr("disabled",true);
                $("#ms__toggle-box").attr("title","Multiship is not compatible with Subscription based orders or Recurring orders.");
                console.log(items[i].id);
                clearInterval(intval);
              }
            }
          });
        }
       }, 200);
  	}

});

$(document).ready(function() {
var acc = $(".accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
});

$(document).ready(function() {
      	$('#one-time').prop("checked", true);
        $('#SingleOptionSelector-0').prop('disabled', true);
//   $('.Quantity-inc').prop('disabled', true);
//   $('.Quantity-dec').prop('disabled', true);
  $(".product-form__input--quantity").val(1);
  $(".product-quantity_span").text("1");
  $('.Quantity-dec').click(function(e){   
    e.preventDefault();
    var quantity = $(".product-quantity_span").text();
    if (quantity > 1){
      quantity --;
    }
    $(".product-quantity_span").text(quantity);
    $(".product-form__input--quantity").val(quantity);
  });
  $('.Quantity-inc').click(function(e){    
    e.preventDefault();
    var quantity = $(".product-quantity_span").text();
    quantity ++;
    $(".product-quantity_span").text(quantity);
    $(".product-form__input--quantity").val(quantity);
  });
});

$(document).ready(function() {
    $('#one-time').change(function() { 
  		$(".product-quantity_span").text("1");
      if(this.checked)
      {
//         var url = window.location.href; 
//         window.location.replace(url.split('?')[0]);
       $('.Quantity-inc').prop('disabled', false);
        $('.Quantity-dec').prop('disabled', false);
        $('#SingleOptionSelector-0').prop('disabled', true);
      $(".livingelixirfrequencynumber").val("");
      $(".livingelixirintervalsunittype").val("");
      $("#Quantity-ss-product-template").val("1");
      $(".product-form__input--quantity").prop("readonly", false);
      $(".livingelixirfrequencynumber").attr('name', '');
      $(".livingelixirintervalsunittype").attr('name', '');
      $(".livingelixiradditional").attr('name', 'properties[additional_details]');
      $(".livingelixiradditional").val("A one-time purchase of the Saint Supply Living Elixir includes a 250 ml/ 8.5 fl.oz bottle of Organic Extra Virgin Olive Oil and one 40ml drinking glass to begin your ritual of resilience.");
      $(".addtocartmain").show();
      $(".subscriptionbutton").hide();        
      $(".product-form__variants").val('36907848532136');
      $("#product_form_5687288791208 .price-item.price-item--regular").text("$68.00");
       $(".shopify-payment-button__more-options").show();  
       $(".paynow-wrapper").hide();
      }
      else {
      }
    });
  $('#SingleOptionSelector-0').change(function() {  
//         $('.Quantity-inc').prop('disabled', true);
//         $('.Quantity-dec').prop('disabled', true);
      	$('#one-time').prop("checked", false);
  		$(".product-quantity_span").text("1");
    	$(".product-form__input--quantity").val(1);
    });
});

$(document).ready(function() {
    $('#subscription').change(function() {   
  		$(".product-quantity_span").text("1");
       $('#SingleOptionSelector-0').trigger('change');
      if(this.checked)
      {
        $('.Quantity-inc').prop('disabled', true);
        $('.Quantity-dec').prop('disabled', true);
        $('#SingleOptionSelector-0').prop('disabled', false);
      $(".livingelixirfrequencynumber").val("1");
      $(".livingelixirintervalsunittype").val("Months");
      $(".product-form__input--quantity").val("1");
      $(".product-form__input--quantity").prop("readonly", true);
      $(".livingelixirfrequencynumber").attr('name', 'properties[shipping_interval_frequency]');
      $(".livingelixirintervalsunittype").attr('name', 'properties[shipping_interval_unit_type]');
//         $(".product-form__variants").val('36907848532136');
//         console.log("+++++++++++++++",properties[Cart Item ID])
      $(".randomproductid").attr('name', 'properties[Cart Item ID]');
//       $(".livingelixiradditional").attr('name', 'properties[additional_details]');
//       $(".livingelixiradditional").val("Includes: <b>1x=</b> introductory Living Elixir box (250 ml/8.5 fl. oz Organic Extra Virgin Olive Oil with a complimentary 40 ml drinking glass). \n 3x additional bottles (250 ml/8.5 fl. oz) for a full month's supply of a daily intake of Saint Supply Living Elixir.");
//       $(".addtocartmain").hide();
//       $(".subscriptionbutton").show();
      $("#product_form_5687288791208 .price-item.price-item--regular").text("$272.00");
//       $(".shopify-payment-button__more-options").hide();  
//       $(".paynow-wrapper").show();
       }
      else {
      }
    });
});

$(document).ready(function() {
  $('#radio_subscribe_select').prop('disabled', true).hide();
  $('#SingleOptionSelector-0').prop('disabled', true).hide();
  $('#subscribe-section').hide();

   $('#radio_onetime').change(function() {
    $('#radio_id').val($(this).val());
     $('#radio_onetime').parent().addClass('active');
     $('#radio_subscribe').parent().removeClass('active');
     $('#SingleOptionSelector-0').prop('disabled', true).hide();
     $('#subscribe-section').hide();
     $(".addtocartmain").show();
     $(".onebottle, .twobottles, .threebottles, .fourbottles").hide();
     $('#radio_subscribe_select').prop('disabled', true).hide();
     $('.product-quantity').show();
     $('#single-section').show();
   });
  $('#radio_subscribe').change(function() {
    $('#radio_id').val($(this).val());
    $('.product-quantity').hide();
    $('#single-section').hide();
    $('#radio_subscribe').parent().addClass('active');
    $('#radio_onetime').parent().removeClass('active');
    $('#SingleOptionSelector-0').prop('disabled', false).show();
    $('#subscribe-section').show();
    $(".addtocartmain").hide();
    $('#radio_subscribe_select').prop('disabled', false).show();
    if ($('.single-option-selector option:selected').val() == '1 Bottle per Month') {
       $(".onebottle").show();
       $(".twobottles, .threebottles, .fourbottles, .addtocartmain").hide();
    }
  });
  $('#radio_subscribe_select').change(function() {
    var $option = $(this).find('option:selected');
    var value = $option.val();
    $('#radio_id').val(value);
  });

    $('.single-option-selector').change(function() {
      if ( this.value == '1 Bottle per Month'){
        $(".onebottle").show();
        $(".twobottles, .threebottles, .fourbottles, .addtocartmain").hide();
      }
      else if ( this.value == '2 Bottles per Month'){
        $(".twobottles").show();
        $(".onebottle, .threebottles, .fourbottles, .addtocartmain").hide();
      } else if (this.value == '3 Bottles per Month'){
        $(".threebottles").show();
        $(".onebottle, .twobottles, .fourbottles, .addtocartmain").hide();
      } else if (this.value == '4 Bottles per Month'){
        $(".fourbottles").show();
        $(".onebottle, .twobottles, .threebottles, .addtocartmain").hide();
      } else {}
    });
});


/*
$('#add-to-cart-form').on('submit', function(event) {
  event.preventDefault(); // prevent default form submission
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).serialize(),
    dataType: 'json',
    success: function(data) {
      console.log(data);
      var description = data.product_description;
      var qty = parseInt($('cart-popup__cta-link span').text(), 10);
      if(qty > 1){
        qty = qty + 1;
      }else{
        qty = 1;
      }
      
      $('.cart-popup-wrapper--hidden').css('transform','none');
      $('.cart-popup-wrapper--hidden').removeClass('cart-popup-wrapper--hidden');
      $('.cart-popup-item__image-wrapper').removeClass('hide').html('<img src="'+data.featured_image.url+'">');
      $('h3.cart-popup-item__title').html(data.untranslated_product_title);
      $('.product-details').html('<li class="product-details__item product-details__item--variant-option">'+data.untranslated_variant_title+'</li><li class="product-details__item product-details__item--property"></li><li class="custom-list-item" style="display:none;"></li>');
      $('.cart-popup-item__quantity span:last-child').html('1');
      $('.cart-popup__cta-link span').html(qty);
      // Do something on success (e.g. show a success message)
    },
    error: function() {
      // Do something on error (e.g. show an error message)
    }
  });
});
*/
